<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>Kore stazje  òf hasi investigashon den kadena hudisial</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Stage</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="single-resume-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="single-resume-item">
                    <div class="single-resume-profile">
                        <div class="row align-items-center">
                            <div class="col-lg-12" style="color: black;">
                               <h3> Bo ta un studiante na MBO/SBO, HBO òf universidat?  </h3> 
                                
                                <p style="color: black;">  Bo ta den e fase final di bo estudio i bo ke gana eksperiensia òf hasi un investigashon den e kadena hudisial di Kòrsou? <br />
                                    Nos ministerio di Hustisia ta e wesu di lomba di e un komunidat safe, liber i hustu. Kaminda tur hende, independientemente di su estilo di bida òf kreensia, por biba den harmonia ku otro. 
                                    Nos ta duna studiantenan talentoso i motivá oportunidat pa gana eksperiensha i hasi investigashon den nos ministerio. 
                                    
                                    <br /><br />Bou di guia di profeshonal den area di orden públiko, resosalisashon, prevenshon abo komo un talento hóben lo tin e oportunidat pa atkerí konosementu i eksperiensia. 
                                    Bo por hasi esaki den un oganisashon ku ta ehekutá un di nos tareanan òf ta traha maneho i lei.
                                <br /><br/>
                                    Bo ta interesá? Klek pa solisitá i manda nos bo CV i motivashon.
                                </p>

                                
                            </div>

                        </div>
                    </div>


                </div>
            </div>

            <div class="col-lg-4">
                <div class="single-resume-item">
                    <div class="single-resume-category">
                        <h3>Apliká</h3>
                        Bo ta interesá?<br /> Klek pa solisitá i manda nos bo CV i motivashon.<br /><br />
                        <a href="mailto:hrm@minjustcur.com" target="_blank"><button  class="btn btn-lg btn-block" style="background:#0b1c38; color:#fff; border-radius:0px; width:100%;">Apliká</button>
                        </a> 
                    </div>
                    


                </div>
            </div>
        </div>
    </div>
</div>